export default {
  delayed: 'DELAYED',
  black_out: 'BLACK OUT',
  // no-dd-sa:javascript-inclusive/identifiers
  client_blacklist: 'CLIENT BLACKLIST',
  reduced_route: 'REDUCED ROUTE',
  limited_reservation: 'LIMITED RESERVATION',
  limited_capacity: 'LIMITED CAPACITY',
};
